import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import ReactDOM from "react-dom";
import ReactPaginate from 'react-paginate';
import { path, dropdownColourStyles } from 'Constants'
import classNames from "classnames";
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment'
import UploadAddressableSpend from './UploadAddressableSpend'
import { routes } from 'Constants'
import {
    integralPartWithBlank,
    roundFix, formatThousands, getNonEmptyValue, roundFixWithBlank, formatThousandsWithBlank, mergeArrayByKey, RoundFormatter2,
    IntegralpartFormatter, IntegralpartPercentFormatter, binarySearchIndex, formatter, filterRenderer, editorComponent
} from 'utils/Utils'
import {
    columnFieldModalStyle,
    suggestedValueContentStyle,
    backdropStyle, changeModalContentStyle, modalContentStyle, changeModalStyle
} from 'Constants';

import {
    dropdownValues, directSpendDropdown, scopeValues, goodsValues, requesitionValues, aribaBuyProcessValues,
    workingCaptialSegmentationValues, VendorLinkFormatter, IndustryLinkFormatter, discountingVals, termRationalizationVals
}
    from '../SpendConstants'

import Modal from 'reboron/OutlineModal'
// Settings
import Select from 'react-select'
import {
    getDetailedFileSuccess,
    getDetailedFileLoading,
    getDetailedFileFailure,
    getAddressableSpendData,
    getSpendColumnsConfiguration,
    getSelectedColumn,
    insertAddressableSpendRecords,
    pendingChanges,
    defineScopeLoading,
    setResultSummaryDetails,
    setTopDetails,
    selectedIndustryDetails,
    selectedEnablementWaveDetails,
    selectedCapIqIdDetails,
    redirectFromEnablementTab,
    detailedFileFilters,
    detailedFileFilterText,
} from 'actions/spendActions'
import TextEditor from 'UI/TextEditor';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data, Filters, Editors, Menu } from "react-data-grid-addons";
import Button from 'UI/Button';
import TextfilterRenderer from 'UI/TextFilterRenderer';
import NumericFilterRenderer from 'UI/NumericFilterRenderer';
import UserCommentsPopUp from '../UserCommentsPopUp'
import IndustryOverridePopUp from '../IndustryOverridePopUp'
import EnablementWavePopUp from '../EnablementWavePopUp'
import Popup from "reactjs-popup";
import VideoHelp from 'components/UI/VideoHelp'
import { PopupE, SelectE } from 'UI/CustomComponents/Controls';
import CapIQSearch from './CapIQSearch';

const changeBackdropStyle = Object.assign({}, backdropStyle);
changeBackdropStyle.zIndex = '1050';

const { ContextMenu, MenuItem, SubMenu, ContextMenuTrigger } = Menu;

const selectors = Data.Selectors;
const {
    NumericFilter,
    AutoCompleteFilter,
    MultiSelectFilter,
    SingleSelectFilter
} = Filters;

// ============================================
// CUSTOM FILTER FOR ADDRESSABLE SPEND COLUMN
// ============================================
// Custom filter for Addressable Spend column (compact native select)
class AddressableSpendFilter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: this.getInitialValue()
        };
        this.selectRef = React.createRef();
    }

    getInitialValue() {
        const { filters, column } = this.props;
        if (filters && filters[column.key]) {
            return filters[column.key].filterTerm;
        }
        return '';
    }

    componentDidUpdate(prevProps) {
        // Sync when filters change (e.g., cleared from breadcrumb)
        if (prevProps.filters !== this.props.filters) {
            const newValue = this.getInitialValue();
            if (newValue !== this.state.value) {
                this.setState({ value: newValue });
            }
        }
    }

    handleChange = (e) => {
        const newValue = e.target.value || null;
        this.setState({ value: newValue || '' });
        this.props.onFilterChange({
            column: this.props.column,
            filterTerm: newValue,
            rawValue: newValue,
            type: 'singleSelect'
        });
    };

    getInputNode() {
        return this.selectRef.current;
    }

    render() {
        return (
            <select
                ref={this.selectRef}
                value={this.state.value || ''}
                onChange={this.handleChange}
                style={{
                    width: '100%',
                    height: 28,
                    fontSize: 12,
                    margin: 0,
                    padding: '2px 4px'
                }}
            >
                <option value="">All</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
            </select>
        );
    }
}

class AddressableSpendEditor extends PureComponent {
    constructor(props) {
        super(props);

        this.selectRef = React.createRef();

        this.state = {
            value: this.normalizeValue(props.value)
        };
    }

    normalizeValue(value) {
        if (
            value === 'Yes' ||
            value === 'Y' ||
            value === true ||
            value === 1
        ) {
            return 'Yes';
        }

        return 'No';
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
            this.setState({
                value: this.normalizeValue(this.props.value)
            });
        }
    }

    handleChange = (e) => {
        const newValue = e.target.value;

        this.setState(
            { value: newValue },
            () => {
                this.props.onCommit();
            }
        );
    };

    getValue() {
        return {
            [this.props.column.key]: this.state.value
        };
    }

    getInputNode() {
        return this.selectRef.current;
    }

    render() {
        return (
            <select
                ref={this.selectRef}
                value={this.state.value}
                onChange={this.handleChange}
                autoFocus
                style={{
                    width: '100%',
                    height: 28,
                    fontSize: 12
                }}
            >
                <option value="Yes">Yes</option>
                <option value="No">No</option>
            </select>
        );
    }
}

class AddressableSpend extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            isBlocking: false,
            isLoading: true,
            isError: 'No',
            responseMsg: '',
            finalSpendData: [],
            RequestIds: [],
            selectedScopes: '',
            fileDetails: [],
            scopes: [],
            pageCount: 1,
            filters: {},
            perPage: 30000,
            paginatedRowFrom: 0,
            paginatedRowTo: 30000,
            columnDefs: [],
            rowData: [],
            filteredRows: [],
            columns: [],
            pageCountOption: [{ label: '1,000', value: 1000 }, { label: '5,000', value: 5000 }, { label: '10,000', value: 10000 }, { label: '15,000', value: 15000 }, { label: '30,000', value: 30000 }],
            filteredRows: [],
            cellUpdateCss: 'bisque',
            open: false,
            openUserCommentsPopUp: false,
            openEnablementInsightPopUp: false,
            userComments: '',
            userCommentsRowNo: -1,
            userCommentInsideCell: '',
            userCommentOverrides: {},
            industryOverrideRowNo: -1,
            pendingRecords: [],
            warningRecords: [],
            errorRecords: [],
            exclusionReason_directSpendUpdates: [],
            warningDiv: true,
            errorDiv: true,
            isFilterVisible: false,
            cleanIndustryOverrides: {},
            confirmedflagTrans: {},
            isCapIQLicesend: false,
            filterArray: [],
            filterDiv: [],
            filterFlag: false,
            summationArray: {},
            filteredSummationArray: {},
            selectedSupplier: -1,
            isSaveInProgress: false,
            openCapIq: false,
            capIqIdOverrideRowNo: -1,
            capIQIdOverrides: {},
            currentCapIqId: '',
            dummyScroll: false,
            actualScroll: false,
            enablementWaveOverrides: {},
            enablementWaveInputValue: null,
            headerToColumn: {},
        }
        this.formatSpendData = this.formatSpendData.bind(this)
        this.handlePageClick = this.handlePageClick.bind(this)
        this.getValidFilterValues = this.getValidFilterValues.bind(this)
        this.handleFilterChange = this.handleFilterChange.bind(this)
        this.handlePageCountChange = this.handlePageCountChange.bind(this)
        this.industryOverride = this.industryOverride.bind(this)
        this.closePopUp = this.closePopUp.bind(this)
        this.outsidePopupClick = this.outsidePopupClick.bind(this)
        this.addUserComments = this.addUserComments.bind(this)
        this.clearUserComments = this.clearUserComments.bind(this)
        this.closeUserCommentsPopUp = this.closeUserCommentsPopUp.bind(this)
        this.outsideUserCommentsPopupClick = this.outsideUserCommentsPopupClick.bind(this)
        this.findRowIndex = this.findRowIndex.bind(this)
        this.filterValidationRecords = this.filterValidationRecords.bind(this)
        this.warningToggle = this.warningToggle.bind(this)
        this.errorToggle = this.errorToggle.bind(this)
        this.isCellEditable = this.isCellEditable.bind(this)
        this.onSave = this.onSave.bind(this)
        this.hasRecordErrors = this.hasRecordErrors.bind(this)
        this.filterChange = this.filterChange.bind(this)
        this.setColumnHelpTextAndHardRefresh = this.setColumnHelpTextAndHardRefresh.bind(this)
        this.setHeaderHelpText = this.setHeaderHelpText.bind(this)
        this.columnResize = this.columnResize.bind(this)
        this.clearIndustryOverride = this.clearIndustryOverride.bind(this)
        this.filterToggle = this.filterToggle.bind(this)
        this.removeFilter = this.removeFilter.bind(this)
        this.expandFilter = this.expandFilter.bind(this)
        this.getRows = this.getRows.bind(this)
        this.hideEmptyColumns = this.hideEmptyColumns.bind(this)
        this.capIqRadioButtonClicked = this.capIqRadioButtonClicked.bind(this)
        this.capIqDataCleared = this.capIqDataCleared.bind(this)
        this.capIqIdOverride = this.capIqIdOverride.bind(this)
        this.closeCapIqPopUp = this.closeCapIqPopUp.bind(this)
        this.outsideCapIqIdPopupClick = this.outsideCapIqIdPopupClick.bind(this)
        this.closeEnablementInsightPopUp = this.closeEnablementInsightPopUp.bind(this)
        this.outsideEnablementInsightPopupClick = this.outsideEnablementInsightPopupClick.bind(this)
        this.enablementWaveInput = this.enablementWaveInput.bind(this);
        this.clearEnablementWaveOverride = this.clearEnablementWaveOverride.bind(this);
        this.actions = this.getApplicationFeatureActions()
        this.getHeaderGroups = this.getHeaderGroups.bind(this)
        this.redirect = this.redirect.bind(this)           
    }

    setColumnHelpTextAndHardRefresh(paginatedRows, columnDefs, isFilterVisible = this.state.isFilterVisible) {
        this.timer = setInterval(() => {
            this.setHeaderHelpText(columnDefs)
        }, 5000);

        if (paginatedRows.length === 0) {
            var grid = this.myOpenGrid;
            if (grid) {
                return grid.base.props.columns
            }
        } else {
            columnDefs = columnDefs.map((col, i) => ({
                ...col,
                hash: new Date().getTime()
            }));
        }

        return columnDefs
    }

    setHeaderHelpText(columnDefs) {
        var grid = this.myOpenGrid;
        if (grid === null || grid === undefined) {
            return;
        }

        var gridCells = ReactDOM.findDOMNode(grid).querySelectorAll('.react-grid-HeaderCell');
        gridCells.forEach((item) => {
            // if (item.classList.length > 1) {
            //     return
            // }
            const headerText = item.innerText;
            var col = columnDefs.findIndex((colDef) => {
                return colDef.name === headerText
            })

            if (col !== -1) {
                item.setAttribute('title', columnDefs[col].helpText)
                if (columnDefs[col].editable) {
                    item.style.backgroundColor = '#ff8c00';
                }
            }
        })
    }

    filterChange() {
        const isFilterVisible = this.state.isFilterVisible
        this.filteredColumnValues = []

        this.setState({ isFilterVisible: !isFilterVisible })
    }

    hasRecordErrors() {
        const errorRecords = this.state.errorRecords
        var errorRecordSize = 0;
        Object.values(errorRecords).forEach((item) => {
            errorRecordSize += item.length;
        })
        
        return errorRecordSize > 0
    }

    isAllAddressableSpendNo = () => {

        const rows = this.state.rowData;
    
        if (!rows || rows.length === 0) {
            return false;
        }
    
        console.log(
            'Yes Count',
            rows.filter(
                r => String(r.ADDRESSABLE_SPEND).toLowerCase() === 'yes'
            ).length
        );
    
        return !rows.some(
            r => String(r.ADDRESSABLE_SPEND).toLowerCase() === 'yes'
        );
    }
    sortRows = (sortColumn, sortDirection) => {

        const comparer = (a, b) => {
    
            let x = a[sortColumn];
            let y = b[sortColumn];
    
            if (x == null) x = '';
            if (y == null) y = '';
    
            if (typeof x === 'string') {
                x = x.toLowerCase();
            }
    
            if (typeof y === 'string') {
                y = y.toLowerCase();
            }
    
            if (x > y) return 1;
            if (x < y) return -1;
    
            return 0;
        };
    
        let filteredRows = [...this.state.filteredRows];
    
        if (sortDirection === 'ASC') {
            filteredRows.sort(comparer);
        } else if (sortDirection === 'DESC') {
            filteredRows.sort((a, b) => comparer(b, a));
        }
    
        this.setState({
            filteredRows,
            gridSortBy: sortColumn,
            gridSortDirection: sortDirection
        });
    };

    handlePageCountChange(value) {
        var result = this.state.pageCountOption.find(page => page.value === value)
        var pageCount = this.state.filteredRows.length / result.value
        this.setState({ perPage: value, paginatedRowFrom: 0, paginatedRowTo: result.value, pageCount: pageCount })
    }

    isCellEditable(e) {

        if (!e || !e.column) return false;

        const editProperty = e.column.editProperty;

        // Allow editing for the new Addressable Spend column
        if (e.column.key === 'ADDRESSABLE_SPEND') {
            return !this.props.readOnly;
        }

        if (e.column.key === 'EXCLUSION_REASON')
            return true;

        if (
            getNonEmptyValue(e.row['EXCLUSION_REASON']) === ''
            &&
            (e.column.key === 'SAP_ARIBA_BUY_PROCESS'
                || e.column.key === 'SOURCING_ELIGIBLE'
                || e.column.key === 'BUYING_INVOICING_ELIGIBLE'
                || e.column.key === 'REQUISITIONABLE'
                || e.column.key === 'REQUISITION_TYPE'
                || e.column.key === 'CONTRACT_INVOICING_ELIGIBLE'
                || e.column.key === 'COMMERCE_AUTOMATION_ELIGIBLE'
                || e.column.key === 'SUPP_CHAIN_COLLAB_ELIGIBLE'
                || e.column.key === 'SAP_FIELDGLASS_ELIGIBLE'
                || e.column.key === 'SAP_CONCUR_ELIGIBLE'
                || e.column.key === 'DISCOUNT_ELIGIBLE'
                || e.column.key === 'SPOT_BUY_ELIGIBLE'
                || e.column.key === 'PRIMARY_BUY_PROCESS_DELIVERED'
                || e.column.key === 'SECONDARY_BUY_PROCESS_DELIVERED'
                || e.column.key === 'OTHER_BUY_PROCESS_DELIVERED')) {
            return true;
        }

        if (e.column.key === 'OVERRIDE_INDUSTRY_ID' && this.state.open)
            return false;

        if (e.column.key === 'CAPIQ_COMPANY_ID' && this.state.openCapIq)
            return false;

        if (e.column.key === 'USER_COMMENT' && this.state.openUserCommentsPopUp)
            return false;

        if (e.column.key === 'ENABLEMENT_WAVE' && this.state.openEnablementInsightPopUp)
            return false;

        if (e.row['DATA_COLLECTIONS_SKEY'] == '')
            return false

        if (editProperty === 'Yes' && !this.props.readOnly) {
            return true;
        }

        if (editProperty === 'Override' && e.column.key === 'EXCLUSION_REASON')
            return e.row['SCOPE_SOURCE'] === 'Override'

        if (editProperty === 'OverrideWithExclusionReason' && getNonEmptyValue(e.row['EXCLUSION_REASON']) === '')
            return e.row['SCOPE_SOURCE'] === 'Override'

        return false;
    }

    columnResize(idx, width) {
        let column = this.state.columnDefs;
        const headerToColumn = { ...this.state.headerToColumn }
        column.map((value, index) => {
            if (index == (Number(idx))) {
                value.width = Number(width)
                const keys = Object.keys(headerToColumn)
                for (let idx2 = 0; idx2 < keys.length; idx2++) {
                    const key = keys[idx2]
                    const val = headerToColumn[key]
                    if (val.name === null && key === value.name) {
                        val.width = value.width
                        break
                    } else if (val instanceof Array) {
                        for (let idx1 = 0; idx1 < val.length; idx1++) {
                            let item = val[idx1]
                            if (item.name === value.name) {
                                item.width = value.width
                                break
                            }
                        }
                    }
                }
                return;
            }
        })

        this.setState({ columnDefs: column, headerToColumn: headerToColumn }, this.forceUpdate())
    }

    findRowIndex(array, value) {
        var low = 0,
            high = array.length;

        while (low < high) {
            var mid = (low + high) >>> 1;
            if (array[mid] === value) return -1
            if (array[mid] < value) low = mid + 1;
            else high = mid;
        }

        return low;
    }

    onGridRowsUpdated = ({ fromRow, toRow, updated }) => {
        const editedColumn = Object.keys(updated)[0];
        if (Object.values(updated)[0] === 'DUMMY' && Object.keys(updated)[0] === 'OVERRIDE_INDUSTRY_ID') {
            return
        }
        if (Object.values(updated)[0] === 'DUMMY' && Object.keys(updated)[0] === 'CAPIQ_COMPANY_ID') {
            return
        }
        if (Object.keys(updated)[0] === 'USER_DATE_FIELD' && Object.values(updated)[0] !== null
            && (Object.values(updated)[0].toLowerCase() === 'invalid date' || Object.values(updated)[0].length !== 10)) {
            return
        }
        fromRow -= 1; toRow -= 1;

        this.setState(state => {
            const finalSpendData = [...state.finalSpendData];
            const filteredRows = [...state.filteredRows];
            const rowData = [...state.rowData];

            const pendingRecords = state.pendingRecords;
            pendingRecords.sort((a, b) => {
                return a - b;
            })

            const colIdx = state.columnDefs.findIndex((item) => {
                return item.key === Object.keys(updated)[0]
            })

            const warningRecords = this.state.warningRecords;
            const errorRecords = this.state.errorRecords;
            const exclusionReason_directSpendUpdates = this.state.exclusionReason_directSpendUpdates;
            var userCommentOverrides = this.state.userCommentOverrides
            var cleanIndustryOverrides = this.state.cleanIndustryOverrides
            var confirmedflagTrans = this.state.confirmedflagTrans
            var capIQIdOverrides = this.state.capIQIdOverrides
            var enablementWaveOverrides = this.state.enablementWaveOverrides

            for (var idx = state.paginatedRowFrom + fromRow, len = (state.paginatedRowFrom + toRow); idx <= len; idx++) {
                const editable = { column: state.columnDefs[colIdx], row: filteredRows[idx] }
                if (!this.isCellEditable(editable) && Object.keys(updated)[0] !== 'OVERRIDE_INDUSTRY_ID' && Object.keys(updated)[0] !== 'USER_COMMENT'
                    && Object.keys(updated)[0] !== 'CAPIQ_COMPANY_ID' && Object.keys(updated)[0] !== 'ENABLEMENT_WAVE') {
                    continue;
                }
                if (Object.keys(updated)[0] === 'USER_COMMENT' && moment(Object.values(updated)[0], 'MM/DD/YYYY', true).isValid() === true) {
                    continue;
                }
                if (filteredRows[idx][editable.column.key] == Object.values(updated)[0])
                    continue;

                var exclusionReason = filteredRows[idx]['EXCLUSION_REASON']
                var directSpend = filteredRows[idx]['DIRECT_SPEND']
                let skey = filteredRows[idx]['DATA_COLLECTIONS_SKEY']

                if (editable.column.key === 'ADDRESSABLE_SPEND') {

                    if (
                        filteredRows[idx]['ADDRESSABLE_SPEND'] !==
                        Object.values(updated)[0]
                    ) {

                        filteredRows[idx]['SCOPE_SOURCE'] = 'Override';
                        updated.SCOPE_SOURCE = 'Override';
                    }
                }

                if (editable.column.key === 'EXCLUSION_REASON') {
                    if (filteredRows[idx]['EXCLUSION_REASON'] != Object.values(updated)[0]) {
                        filteredRows[idx]['SCOPE_SOURCE'] = 'Override';
                        updated.SCOPE_SOURCE = 'Override';
                    }
                }

                if (editable.column.key === 'SAP_ARIBA_BUY_PROCESS') {
                    if (filteredRows[idx]['SAP_ARIBA_BUY_PROCESS'] != Object.values(updated)[0]) {
                        filteredRows[idx]['SCOPE_SOURCE'] = 'Override';
                        updated.SCOPE_SOURCE = 'Override';
                        filteredRows[idx]['EXCLUSION_REASON'] = '';
                    }
                }
                if (editable.column.key === 'SOURCING_ELIGIBLE') {
                    if (filteredRows[idx]['SOURCING_ELIGIBLE'] != Object.values(updated)[0]) {
                        filteredRows[idx]['SCOPE_SOURCE'] = 'Override';
                        updated.SCOPE_SOURCE = 'Override';
                        filteredRows[idx]['EXCLUSION_REASON'] = '';
                    }
                }
                if (editable.column.key === 'BUYING_INVOICING_ELIGIBLE') {
                    if (filteredRows[idx]['BUYING_INVOICING_ELIGIBLE'] != Object.values(updated)[0]) {
                        filteredRows[idx]['SCOPE_SOURCE'] = 'Override';
                        updated.SCOPE_SOURCE = 'Override';
                        filteredRows[idx]['EXCLUSION_REASON'] = '';
                    }
                }
                if (editable.column.key === 'REQUISITIONABLE') {
                    if (filteredRows[idx]['REQUISITIONABLE'] != Object.values(updated)[0]) {
                        filteredRows[idx]['SCOPE_SOURCE'] = 'Override';
                        updated.SCOPE_SOURCE = 'Override';
                        filteredRows[idx]['EXCLUSION_REASON'] = '';
                    }
                }
                if (editable.column.key === 'REQUISITION_TYPE') {
                    if (filteredRows[idx]['REQUISITION_TYPE'] != Object.values(updated)[0]) {
                        filteredRows[idx]['SCOPE_SOURCE'] = 'Override';
                        updated.SCOPE_SOURCE = 'Override';
                        filteredRows[idx]['EXCLUSION_REASON'] = '';
                    }
                }
                if (editable.column.key === 'CONTRACT_INVOICING_ELIGIBLE') {
                    if (filteredRows[idx]['CONTRACT_INVOICING_ELIGIBLE'] != Object.values(updated)[0]) {
                        filteredRows[idx]['SCOPE_SOURCE'] = 'Override';
                        updated.SCOPE_SOURCE = 'Override';
                        filteredRows[idx]['EXCLUSION_REASON'] = '';
                    }
                }
                if (editable.column.key === 'COMMERCE_AUTOMATION_ELIGIBLE') {
                    if (filteredRows[idx]['COMMERCE_AUTOMATION_ELIGIBLE'] != Object.values(updated)[0]) {
                        filteredRows[idx]['SCOPE_SOURCE'] = 'Override';
                        updated.SCOPE_SOURCE = 'Override';
                        filteredRows[idx]['EXCLUSION_REASON'] = '';
                    }
                }
                if (editable.column.key === 'SUPP_CHAIN_COLLAB_ELIGIBLE') {
                    if (filteredRows[idx]['SUPP_CHAIN_COLLAB_ELIGIBLE'] != Object.values(updated)[0]) {
                        filteredRows[idx]['SCOPE_SOURCE'] = 'Override';
                        updated.SCOPE_SOURCE = 'Override';
                        filteredRows[idx]['EXCLUSION_REASON'] = '';
                    }
                }
                if (editable.column.key === 'SAP_FIELDGLASS_ELIGIBLE') {
                    if (filteredRows[idx]['SAP_FIELDGLASS_ELIGIBLE'] != Object.values(updated)[0]) {
                        filteredRows[idx]['SCOPE_SOURCE'] = 'Override';
                        updated.SCOPE_SOURCE = 'Override';
                        filteredRows[idx]['EXCLUSION_REASON'] = '';
                    }
                }
                if (editable.column.key === 'SAP_CONCUR_ELIGIBLE') {
                    if (filteredRows[idx]['SAP_CONCUR_ELIGIBLE'] != Object.values(updated)[0]) {
                        filteredRows[idx]['SCOPE_SOURCE'] = 'Override';
                        updated.SCOPE_SOURCE = 'Override';
                        filteredRows[idx]['EXCLUSION_REASON'] = '';
                    }
                }
                if (editable.column.key === 'DISCOUNT_ELIGIBLE') {
                    if (filteredRows[idx]['DISCOUNT_ELIGIBLE'] != Object.values(updated)[0]) {
                        filteredRows[idx]['SCOPE_SOURCE'] = 'Override';
                        updated.SCOPE_SOURCE = 'Override';
                        filteredRows[idx]['EXCLUSION_REASON'] = '';
                    }
                }
                if (editable.column.key === 'SPOT_BUY_ELIGIBLE') {
                    if (filteredRows[idx]['SPOT_BUY_ELIGIBLE'] != Object.values(updated)[0]) {
                        filteredRows[idx]['SCOPE_SOURCE'] = 'Override';
                        updated.SCOPE_SOURCE = 'Override';
                        filteredRows[idx]['EXCLUSION_REASON'] = '';
                    }
                }
                if (editable.column.key === 'PRIMARY_BUY_PROCESS_DELIVERED') {
                    if (filteredRows[idx]['PRIMARY_BUY_PROCESS_DELIVERED'] != Object.values(updated)[0]) {
                        filteredRows[idx]['SCOPE_SOURCE'] = 'Override';
                        updated.SCOPE_SOURCE = 'Override';
                        filteredRows[idx]['EXCLUSION_REASON'] = '';
                    }
                }
                if (editable.column.key === 'SECONDARY_BUY_PROCESS_DELIVERED') {
                    if (filteredRows[idx]['SECONDARY_BUY_PROCESS_DELIVERED'] != Object.values(updated)[0]) {
                        filteredRows[idx]['SCOPE_SOURCE'] = 'Override';
                        updated.SCOPE_SOURCE = 'Override';
                        filteredRows[idx]['EXCLUSION_REASON'] = '';
                    }
                }
                if (editable.column.key === 'OTHER_BUY_PROCESS_DELIVERED') {
                    if (filteredRows[idx]['OTHER_BUY_PROCESS_DELIVERED'] != Object.values(updated)[0]) {
                        filteredRows[idx]['SCOPE_SOURCE'] = 'Override';
                        updated.SCOPE_SOURCE = 'Override';
                        filteredRows[idx]['EXCLUSION_REASON'] = '';
                    }
                }

                if (editable.column.key === 'OVERRIDE_INDUSTRY_ID') {
                    if (cleanIndustryOverrides[skey] === undefined) {
                        cleanIndustryOverrides[skey] = { old: filteredRows[idx]['OVERRIDE_INDUSTRY_ID'], new: Object.values(updated)[0] }
                    } else {
                        cleanIndustryOverrides[skey] = { old: cleanIndustryOverrides[skey].old, new: Object.values(updated)[0] }
                    }
                }

                if (editable.column.key === 'USER_COMMENT') {
                    if (userCommentOverrides[skey] === undefined) {
                        userCommentOverrides[skey] = { old: filteredRows[idx]['USER_COMMENT'], new: Object.values(updated)[0] }
                    } else {
                        userCommentOverrides[skey] = { old: userCommentOverrides[skey].old, new: Object.values(updated)[0] }
                    }
                }

                if (editable.column.key === 'CONFIRMED') {
                    if (confirmedflagTrans[skey] === undefined) {
                        confirmedflagTrans[skey] = { old: filteredRows[idx]['CONFIRMED'], new: Object.values(updated)[0] }
                    } else {

                        confirmedflagTrans[skey] = { old: confirmedflagTrans[skey].old, new: Object.values(updated)[0] }
                    }
                }

                if (editable.column.key === 'CAPIQ_COMPANY_ID') {
                    if (capIQIdOverrides[skey] === undefined) {
                        capIQIdOverrides[skey] = { old: filteredRows[idx]['CAPIQ_COMPANY_ID'], new: Object.values(updated)[0] }
                    } else {
                        capIQIdOverrides[skey] = { old: capIQIdOverrides[skey].old, new: Object.values(updated)[0] }
                    }
                }

                if (editable.column.key === 'ENABLEMENT_WAVE') {
                    updated.ENABLEMENT_WAVE_OVERRIDE = updated.ENABLEMENT_WAVE !== "" ? 'Override' : 'Calculated'
                    if (enablementWaveOverrides[skey] === undefined) {
                        enablementWaveOverrides[skey] = { old: filteredRows[idx]['ENABLEMENT_WAVE'], new: Object.values(updated)[0] }
                    } else {
                        enablementWaveOverrides[skey] = { old: enablementWaveOverrides[skey].old, new: Object.values(updated)[0] }
                    }
                }

                if (editable.column.key === 'SAP_ARIBA_BUY_ENABLE_MTHD_RECMD') {
                    updated.ENABLEMENT_RECOMMENDATION_OVERRIDE = 'Override'
                }

                if (editable.column.key === 'ONBOARDING_WORKSTREAM_DETAILS') {
                    updated.ONBOARDING_WORKSTREAM_DETAILS = updated.ONBOARDING_WORKSTREAM_DETAILS === "Null" ? '' : updated.ONBOARDING_WORKSTREAM_DETAILS
                    updated.ONBOARDING_WORKSTREAM_DETAILS_OVERRIDE = 'Override'
                }

                filteredRows[idx] = {
                    ...filteredRows[idx],
                    ...updated,
                    ADDRESSABLE_SPEND:
                        updated.ADDRESSABLE_SPEND !== undefined
                            ? updated.ADDRESSABLE_SPEND
                            : filteredRows[idx].ADDRESSABLE_SPEND
                };

                rowData.sort((a, b) => { return a['DATA_COLLECTIONS_SKEY'] - b['DATA_COLLECTIONS_SKEY'] })
                var rowIdx = binarySearchIndex(rowData, skey, 'DATA_COLLECTIONS_SKEY')
                rowData[rowIdx] = {
                    ...rowData[rowIdx],
                    ...updated,
                    ADDRESSABLE_SPEND:
                        updated.ADDRESSABLE_SPEND !== undefined
                            ? updated.ADDRESSABLE_SPEND
                            : rowData[rowIdx].ADDRESSABLE_SPEND
                };

                const finalSpendData = [...state.finalSpendData];

                const finalIdx = finalSpendData.findIndex(
                    r => r.DATA_COLLECTIONS_SKEY === skey
                );

                if (finalIdx !== -1) {
                    finalSpendData[finalIdx] = {
                        ...finalSpendData[finalIdx],
                        ...updated
                    };
                }


                var recordIdx = this.findRowIndex(pendingRecords, skey);
                if (recordIdx >= 0) {
                    pendingRecords.splice(recordIdx, 0, skey);
                }

                if ((Object.keys(updated)[0] === "EXCLUSION_REASON" && Object.values(updated)[0] !== exclusionReason)
                    || (Object.keys(updated)[0] === "DIRECT_SPEND" && Object.values(updated)[0] !== directSpend)) {
                    if (!exclusionReason_directSpendUpdates.includes(skey))
                        exclusionReason_directSpendUpdates.push(skey)
                }

                this.validateForWarning(filteredRows[idx], warningRecords, editedColumn);
                this.validateForError(filteredRows[idx], errorRecords, editedColumn);
            }
            return {
                finalSpendData: finalSpendData,
                responseMsg: '',
                confirmedflagTrans: confirmedflagTrans,
                cleanIndustryOverrides: cleanIndustryOverrides,
                userCommentOverrides: userCommentOverrides,
                capIQIdOverrides: capIQIdOverrides,
                enablementWaveOverrides: enablementWaveOverrides,
                rowData: rowData, filteredRows: filteredRows, fromRow: fromRow, toRow: toRow, updated: updated,
                pendingRecords: pendingRecords, warningRecords: warningRecords, errorRecords: errorRecords, exclusionReason_directSpendUpdates
            };
        });
    };

    warningValidationMap = {
        EXCLUSION_REASON: ['exclusionReasonWarning'],

        BUYING_INVOICING_ELIGIBLE: [
            'buyingInvoicingFieldGlassEligibleWarning',
            'buyingInvoicingSupplyChainEligibleWarning',
            'buyingInvoicingConcurEligibleWarning'
        ],

        SAP_FIELDGLASS_ELIGIBLE: [
            'buyingInvoicingFieldGlassEligibleWarning',
            'fieldGlassSCCEligibleWarning'
        ],

        SUPP_CHAIN_COLLAB_ELIGIBLE: [
            'buyingInvoicingSupplyChainEligibleWarning',
            'fieldGlassSCCEligibleWarning'
        ],

        SAP_CONCUR_ELIGIBLE: [
            'buyingInvoicingConcurEligibleWarning'
        ],

        DISCOUNT_ELIGIBLE: [
            'discountAndTermRationalizationEligibleWarning',
            'discountEligibleWarning'
        ],

        TERMS_RATIONALIZATION: [
            'discountAndTermRationalizationEligibleWarning',
            'termRationalizationWarning'
        ],

        WORKING_CAPTIAL_SEGMENTATION: [
            'discountEligibleWarning',
            'termRationalizationWarning'
        ]
    };

    errorValidationMap = {
        BUYING_INVOICING_ELIGIBLE: ['buyingInvoicingError', 'requisitionableTypeError3', 'contractInvoicingError'],
        REQUISITIONABLE: ['buyingInvoicingError', 'requisitionableTypeError1', 'requisitionableTypeError2', 'requisitionableTypeError3'],
        CONTRACT_INVOICING_ELIGIBLE: ['buyingInvoicingError', 'contractInvoicingError'],
        REQUISITION_TYPE: ['requisitionableTypeError1', 'requisitionableTypeError2'],
        SUPP_CHAIN_COLLAB_ELIGIBLE: ['supplyCommerceError'],
        COMMERCE_AUTOMATION_ELIGIBLE: ['supplyCommerceError']
    };

    validateForWarning(record, warningRecords, editedColumn) {
        const warningMessages = this.props.content.validationMessage.warningMessage;
        const rulesToRun = this.warningValidationMap[editedColumn];

        if (!rulesToRun) return;

        var exclusionReason = record['EXCLUSION_REASON'];
        var buyingInvoicing = record['BUYING_INVOICING_ELIGIBLE'];
        var fieldGlassEligible = record['SAP_FIELDGLASS_ELIGIBLE'];
        var supplyChainEligible = record['SUPP_CHAIN_COLLAB_ELIGIBLE'];
        var concurEligible = record['SAP_CONCUR_ELIGIBLE'];
        var discountEligible = record['DISCOUNT_ELIGIBLE'];
        var termRationalizationEligible = record['TERMS_RATIONALIZATION'];

        var workingCapital = record['WORKING_CAPTIAL_SEGMENTATION'];
        workingCapital = workingCapital ? workingCapital.trim() : '';

        if (rulesToRun.indexOf('discountEligibleWarning') !== -1) {
            this.addWarningErroredRecord(
                warningMessages.discountEligibleWarning,
                record,
                warningRecords,
                getNonEmptyValue(discountEligible) === 'Yes' &&
                discountingVals.indexOf(getNonEmptyValue(workingCapital)) === -1
            );
        }

        if (rulesToRun.indexOf('termRationalizationWarning') !== -1) {
            this.addWarningErroredRecord(
                warningMessages.termRationalizationWarning,
                record,
                warningRecords,
                getNonEmptyValue(termRationalizationEligible) === 'Yes' &&
                termRationalizationVals.indexOf(getNonEmptyValue(workingCapital)) === -1
            );
        }
    }

    validateForError(record, errorRecords, editedColumn) {
        const errorMessages = this.props.content.validationMessage.errorMessage;
        const rulesToRun = this.errorValidationMap[editedColumn];

        if (!rulesToRun) return;

        const buyingInvoicing = record['BUYING_INVOICING_ELIGIBLE'];
        const requisitionable = record['REQUISITIONABLE'];
        const contractInvoicing = record['CONTRACT_INVOICING_ELIGIBLE'];
        const requisitionableType = record['REQUISITION_TYPE'];
        const supplyChain = record['SUPP_CHAIN_COLLAB_ELIGIBLE'];
        const commerceAutomation = record['COMMERCE_AUTOMATION_ELIGIBLE'];

        if (rulesToRun.includes('buyingInvoicingError')) {
            this.addWarningErroredRecord(
                errorMessages.buyingInvoicingError,
                record,
                errorRecords,
                (getNonEmptyValue(buyingInvoicing) === 'Yes' &&
                    getNonEmptyValue(requisitionable) === 'Yes' &&
                    getNonEmptyValue(contractInvoicing) === 'Yes') ||
                (getNonEmptyValue(buyingInvoicing) === 'Yes' &&
                    getNonEmptyValue(requisitionable) === 'No' &&
                    getNonEmptyValue(contractInvoicing) === 'No')
            );
        }

        if (rulesToRun.includes('requisitionableTypeError1')) {
            this.addWarningErroredRecord(
                errorMessages.requisitionableTypeError1,
                record,
                errorRecords,
                getNonEmptyValue(requisitionable) === 'Yes' &&
                getNonEmptyValue(requisitionableType) === 'N/A'
            );
        }

        if (rulesToRun.includes('requisitionableTypeError2')) {
            this.addWarningErroredRecord(
                errorMessages.requisitionableTypeError2,
                record,
                errorRecords,
                getNonEmptyValue(requisitionable) === 'No' &&
                getNonEmptyValue(requisitionableType) !== 'N/A'
            );
        }

        if (rulesToRun.includes('requisitionableTypeError3')) {
            this.addWarningErroredRecord(
                errorMessages.requisitionableTypeError3,
                record,
                errorRecords,
                getNonEmptyValue(requisitionable) === 'Yes' &&
                getNonEmptyValue(buyingInvoicing) === 'No'
            );
        }

        if (rulesToRun.includes('contractInvoicingError')) {
            this.addWarningErroredRecord(
                errorMessages.contractInvoicingError,
                record,
                errorRecords,
                getNonEmptyValue(contractInvoicing) === 'Yes' &&
                getNonEmptyValue(buyingInvoicing) === 'No'
            );
        }

        if (rulesToRun.includes('supplyCommerceError')) {
            this.addWarningErroredRecord(
                errorMessages.supplyCommerceError,
                record,
                errorRecords,
                getNonEmptyValue(supplyChain) === 'Yes' &&
                getNonEmptyValue(commerceAutomation) === 'Yes'
            );
        }
    }

    addWarningErroredRecord(reason, record, records, add) {
        var arr = records[reason];
        if (getNonEmptyValue(arr) === '') {
            arr = []
        }

        var eltIdx = arr.indexOf((record['DATA_COLLECTIONS_SKEY']));
        if (eltIdx === -1 && add) {
            arr.push(record['DATA_COLLECTIONS_SKEY'])
        } else if (eltIdx !== -1 && !add) {
            arr.splice(eltIdx, 1)
        }

        records[reason] = arr;
    }

    onSave() {
        const pendingRecords = this.state.pendingRecords;
        if (pendingRecords.length === 0) {
            return;
        }

        this.props.defineScopeLoading(true)        
        this.setState({ isLoading: true, isError: 'No', responseMsg: '', isSaveInProgress: true })
        const rowData = this.state.rowData

        const recordsToInsert = [];

        pendingRecords.forEach((item) => {

            rowData.sort((a, b) => {
                return a['DATA_COLLECTIONS_SKEY'] - b['DATA_COLLECTIONS_SKEY']
            });

            var rowIdx = binarySearchIndex(
                rowData,
                item,
                'DATA_COLLECTIONS_SKEY'
            );

            const row = rowData[rowIdx];

            // clone full editable row
            const record = {
                DATA_COLLECTIONS_SKEY: row.DATA_COLLECTIONS_SKEY,
                ADDRESSABLE_SPEND: row.ADDRESSABLE_SPEND,
                SUPPLIER_ID: row.VENDOR_ID,
                VS_ID: this.props.spendDetails.currentActiveRequest.VS_ID,
                DMC_ID: this.props.spendDetails.currentActiveRequest.DMC_ID,
                USER_ID: this.props.user.user.Email
            };

            recordsToInsert.push(record);
        });

        
        this.props.insertAddressableSpendRecords(recordsToInsert)
            .then((response) => {


                this.props.defineScopeLoading(false)
                this.props.pendingChanges(null)


                this.setState({ confirmedflagTrans: {}, cleanIndustryOverrides: {}, capIQIdOverrides: {}, enablementWaveOverrides: {}, rowData: rowData, pendingRecords: [], errorRecords: [], warningRecords: [], exclusionReason_directSpendUpdates: [], responseMsg: 'Record/s has been updated successfully', isError: 'No', isLoading: false, isSaveInProgress: false },
                    () => this.filteredColumnValues = [])
            }).catch((error) => {
                if (error.stack.includes('Network Error')) {
                    this.props.defineScopeLoading(false)
                    this.setState({ responseMsg: 'API service is down. Please contact administrator.', isError: 'Yes', isLoading: false, isSaveInProgress: false })
                }
                else {
                    this.props.defineScopeLoading(false)
                    this.setState({ responseMsg: this.props.content.error, isError: 'Yes', isLoading: false, isSaveInProgress: false })
                }
            })
    }

    RowRenderer = ({ renderBaseRow, ...props }) => {
        if (props.row.superHeader && Object.keys(props.row.superHeader).length > 0) {
            const value = props.row.superHeader
            let left = 0
            let headerGroupDiv = Object.keys(value).map((key, index) => {
                const val = value[key]
                let row = {}
                if (val.name === null) {
                    let cellValue = (<div className='react-grid-HeaderCell react-grid-HeaderCell-Group'
                        style={{ position: 'absolute', width: `${val.width}px`, height: '35px', left: `${left}px`, backgroundColor: '#ffffff', }}>
                        <div className='react-grid-HeaderCell-sortable'>
                        </div>
                    </div>)

                    left = left + val.width

                    return cellValue
                } else {
                    let width = 0
                    val.forEach(item => {
                        width = width + item.width
                    })
                    let cellValue = (<div className='react-grid-HeaderCell react-grid-HeaderCell-Group'
                        style={{ textAlign: 'left', position: 'absolute', width: `${width}px`, height: '35px', left: `${left}px`, backgroundColor: '#7f7f7f', color: '#ffffff', textOverflow: 'ellipsis', whiteSpace: 'nowrap', transform: 'none' }}>
                        <div title={key} className='react-grid-HeaderCell-sortable'>
                            {key}
                        </div>
                    </div>)

                    val.forEach(item => {
                        left = left + item.width
                    })

                    return cellValue
                }
            })

            return <div className='react-grid-HeaderRow1' style={{ height: '35px', overflow: 'hidden' }}>{headerGroupDiv}</div>
        }

        if (this.state.pendingRecords.length === 0) {
            return renderBaseRow(props);
        }

        let backgroundColor = '';

        const isRemovedFromValueStory =
    String(props.row.ADDRESSABLE_SPEND).toLowerCase() === 'no';

if (isRemovedFromValueStory) {
    backgroundColor = '#ffebeb';
}

        let textAlign = 'left';

        const pendingRecords = this.state.pendingRecords;
        const warningRecords = this.state.warningRecords;
        const errorRecords = this.state.errorRecords;

        Object.values(pendingRecords).every((item) => {
            if (item === props.row.DATA_COLLECTIONS_SKEY) {
                backgroundColor = 'lightgray'
                return false
            } else {
                return true
            }
        })

        Object.values(warningRecords).forEach((itemArr) => {
            itemArr.every(item => {
                if (item === props.row.DATA_COLLECTIONS_SKEY) {
                    backgroundColor = 'yellow'
                    return false
                } else {
                    return true
                }
            })
        })

        Object.values(errorRecords).forEach((itemArr) => {
            itemArr.every(item => {
                if (item === props.row.DATA_COLLECTIONS_SKEY) {
                    backgroundColor = 'red'
                    return false
                } else {
                    return true
                }
            })
        })

        return <div style={{ backgroundColor }}>{renderBaseRow(props)}</div>;

    };

    componentDidMount() {
        this.props.defineScopeLoading(true)
        this.loadData();
        window.scrollTo(0, 0);
        this.setState({
            isCapIQLicesend: this.props.user.user.applicationFeatures.findIndex(a => a.Action === this.props.content.capIQAction) > -1 ? true : false,
        })
    }

    getApplicationFeatureActions() {
        let actions = [];
        let applicationFeatures = this.props.user && this.props.user.user && this.props.user.user.applicationFeatures ? this.props.user.user.applicationFeatures : [];
        applicationFeatures.map(applicationFeat => {
            actions.push(applicationFeat.Action);
        })
        return actions;
    }

    getTableColumn(self, fieldName, fieldConfig) {
        let tableColumn = {
            name: fieldConfig.screen_field_name,
            key: fieldName,
            width: 120,
            sortable: true,
            editable: false,
            resizable: true,
            filterable: true,
            screenSeq: fieldConfig.screen_seq,
            formatter: formatter(fieldConfig.alignment),
            filterRenderer: filterRenderer(fieldConfig.filter_type),
            helpText: fieldConfig.screen_help_text,
            hash: (new Date()).getTime(),
            headerGroup: fieldConfig.headerGroup,
            label: fieldConfig.excel_col_name
        };

        // ============================================
        // ADDRESSABLE SPEND COLUMN (Editable Dropdown)
        // ============================================
        if (fieldName === 'ADDRESSABLE_SPEND') {
            tableColumn = {
                ...tableColumn,
                name: "Addressable Spend",
                key: "ADDRESSABLE_SPEND",
        
                // Freeze column
                frozen: true,
        
                // editable: (row) => {
                //     return (
                //         row.DATA_COLLECTIONS_SKEY !== 'Total :' &&
                //         row.REF_NUMBER !== 'Total :' &&
                //         row.DATA_COLLECTIONS_SKEY !== undefined
                //     );
                // },

                editable: true,
        
                editProperty: 'Yes',
        
                editor: AddressableSpendEditor,
        
                width: 200,
        
                sortable: true,
        
                // Enable filter
                filterable: true,
        
                // Use the custom filter component (fixes dropdown & z-index issues)
                filterRenderer: AddressableSpendFilter,
        
                // IMPORTANT: removed the old 'filter' prop to avoid conflicts
                helpText:
                    'When "Yes" is selected the supplier record is included in the value story and all reporting. When "No" is selected the supplier record is removed from the value story and not included in reporting.',
        
                formatter: ({ value }) => {
        
                    if (
                        value === undefined ||
                        value === null ||
                        value === ''
                    ) {
                        return null;
                    }
        
                    const normalized =
                        value === 'Yes' ||
                        value === 'Y' ||
                        value === true ||
                        value === 1;
        
                    return (
                        <div
                            style={{
                                backgroundColor: normalized
                                    ? ''
                                    : '#ffebeb',
                                height: '100%',
                                width: '100%',
                                padding: '4px'
                            }}
                        >
                            {normalized ? 'Yes' : 'No'}
                        </div>
                    );
                }
            };
        }

        // Keep any other special field handling (OVERRIDE_INDUSTRY_ID, CAPIQ_COMPANY_ID, etc.)
        // from your original code here...

        return tableColumn;
    }

    breakNumberInSet(number, n) {
        const values = [];
        let times = number;
        while (times > 0) {
            if (times >= n)
                values.push(n);
            else
                values.push(times);
            times = times - n;
        }
        return values;
    }


    async loadData() {
        this.props.defineScopeLoading(true)
        this.setState({ finalSpendData: [], isLoading: true, responseMsg: '', isError: 'No' })

        this.props.getAddressableSpendData(this.props.spendDetails.currentActiveRequest.DMC_ID, this.props.spendDetails.currentActiveRequest.VS_ID,
            this.props.user.user.Email)
            .then((response) => {
                let finalSpendData = [];
                finalSpendData = response.data.Result;
                finalSpendData = finalSpendData.sort((a, b) => a.DATA_COLLECTIONS_SKEY - b.DATA_COLLECTIONS_SKEY);
                this.setState({ finalSpendData: finalSpendData }, () => this.formatSpendData());
                finalSpendData = [];
            })
    }

    formatSpendData() {

        this.props.getSpendColumnsConfiguration()
            .then((response) => {

                const colConfig = response.data.Result;
                const colConfigArr = [];

                colConfig.forEach((item) => {
                    for (var key in item) {
                        if (key === 'field') {
                            colConfigArr[item[key]] = item;
                            break;
                        }
                    }
                });

                this.setState({
                    responseMsg: '',
                    isError: 'No'
                });

                var self = this;

                var column = [];

                for (var i = 0; i < this.state.finalSpendData.length; i++) {

                    column = Object.keys(this.state.finalSpendData[0]);

                    if (i === 0)
                        break;
                }

                const fieldIdx = column.indexOf('INDUSTRY_SCOPE_TYPE');

                if (fieldIdx !== -1) {
                    column.splice(fieldIdx, 1);
                }

                if (column.indexOf('VS_ID') !== -1) {
                    column.splice(column.indexOf('VS_ID'), 1);
                }

                if (column.indexOf('DMC_ID') !== -1) {
                    column.splice(column.indexOf('DMC_ID'), 1);
                }

                if (column.length === 0) {

                    this.props.defineScopeLoading(false);

                    this.setState({
                        responseMsg: this.props.content.noData,
                        isError: 'Yes',
                        isLoading: false
                    });

                    return;
                }

                var finalColumn = [];
                var colOptions = [];
                var defaultScreenColumns = [];
                var tableColumn = {};

                for (let index = 0; index < column.length; index++) {

                    const fieldName = column[index];

                    // =========================
                    // CUSTOM CHECKBOX COLUMN
                    // =========================

                    if (fieldName === 'ADDRESSABLE_SPEND') {

                        tableColumn = this.getTableColumn(
                            self,
                            fieldName,
                            {
                                screen_field_name: 'Visible',
                                screen_seq: 0,
                                alignment: 'center',
                                filter_type: '',
                                screen_help_text: '',
                                headerGroup: '',
                                excel_col_name: 'Visible'
                            }
                        );

                        finalColumn.push(tableColumn);
                        defaultScreenColumns.push(tableColumn);

                        colOptions.push({
                            id: fieldName,
                            label: 'Visible',
                            seq: 0,
                            value: tableColumn,
                            isSelected: true
                        });

                        continue;
                    }

                    const fieldConfig = colConfigArr[fieldName];

                    // =========================
                    // IGNORE INVALID CONFIG
                    // =========================
                    if (!fieldConfig) {                        
                        continue;
                    }

                    tableColumn = this.getTableColumn(
                        self,
                        fieldName,
                        fieldConfig
                    );

                    tableColumn.filter_type = fieldConfig.filter_type;
                    tableColumn.alignment = fieldConfig.alignment;

                    finalColumn.push(tableColumn);

                    let colOption = {
                        id: fieldName,
                        label: fieldConfig.screen_field_name,
                        seq: fieldConfig.screen_seq,
                        columnCategory: fieldConfig.column_category,
                        value: tableColumn,
                        is_default: fieldConfig.is_default,
                        internalEnablementInsightView: fieldConfig.internalEnablementInsightView,
                        externalEnablementInsightView: fieldConfig.externalEnablementInsightView,
                        categoryInsightsView: fieldConfig.categoryInsightsView,
                        enterpriseEnablementEstimatesView: fieldConfig.enterpriseEnablementEstimatesView,
                        matchAndClassification_export: fieldConfig.matchAndClassification_export,
                        sccEnableInsightView: fieldConfig.SccEnableInsightView,
                        sccView: fieldConfig.SccView,
                        allSccView: fieldConfig.allSccView,
                        isSelected: true
                    };

                    defaultScreenColumns.push(tableColumn);

                    if (fieldConfig.showOnUi === 'Yes') {
                        colOptions.push(colOption);
                    }
                }

                if (defaultScreenColumns.length > 0) {
                    defaultScreenColumns = defaultScreenColumns.sort(
                        (a, b) => a.screenSeq - b.screenSeq
                    );
                }

                if (colOptions.length > 0) {
                    colOptions = colOptions.sort(
                        (a, b) => a.seq - b.seq
                    );
                }

                var finalRows = [];
                var finalFilteredRows = [];

                let isColumnEmpty = {};

                for (let rowindex = 0;
                    rowindex < this.state.finalSpendData.length;
                    rowindex++) {

                    var row = {
                        isCapIQLicesend: self.state.isCapIQLicesend,
                        isUserDefinedRowUpdated: 'No'
                    };

                    for (let Cindex = 0;
                        Cindex < finalColumn.length;
                        Cindex++) {

                        const element = finalColumn[Cindex];

                        var item = element["key"];

                        var itemVal =
                            this.state.finalSpendData[rowindex][item] === null
                                ? ''
                                : this.state.finalSpendData[rowindex][item];

                        isColumnEmpty[item] =
                            isColumnEmpty[item] !== undefined
                                ? isColumnEmpty[item] && itemVal === ''
                                : itemVal === '';

                        row[item] = itemVal;
                    }

                    finalRows.push(row);
                }

                let emptyColumns = [];

                Object.keys(isColumnEmpty).forEach(key => {

                    if (
                        isColumnEmpty[key] &&
                        !([
                            'EXCLUSION_REASON',
                            'OVERRIDE_INDUSTRY_ID',
                            'DIRECT_SPEND',
                            'USER_COMMENT',
                            'ADDRESSABLE_SPEND'
                        ].includes(key))
                    ) {
                        emptyColumns.push(key);
                    }
                });

                for (const key of emptyColumns) {

                    let idx = defaultScreenColumns.findIndex(item => {
                        return item.key === key;
                    });

                    // if (idx !== -1) {
                    //     defaultScreenColumns.splice(idx, 1);
                    // }

                    idx = colOptions.findIndex(item => {
                        return item.id === key;
                    });

                    if (idx !== -1) {
                        colOptions[idx].isSelected = false;
                    }
                }

                let summationArray = this.sum(
                    finalRows,
                    defaultScreenColumns
                );

                finalRows = finalRows.sort(
                    (a, b) => a['DATA_COLLECTIONS_SKEY'] - b['DATA_COLLECTIONS_SKEY']
                );

                finalFilteredRows = [...finalRows];

                var pageCount =
                    finalRows.length / this.state.perPage;

                this.originalColumns = cloneDeep(colOptions);

                const headerToColumn =
                    this.getHeaderGroups(defaultScreenColumns);

                this.props.defineScopeLoading(false);

                this.setState({
                    columns: colOptions,
                    columnDefs: defaultScreenColumns,
                    rowData: finalRows,
                    filteredRows: finalFilteredRows,
                    pageCount: pageCount,
                    isError: 'No',
                    isLoading: false,
                    summationArray: summationArray,
                    filteredSummationArray: { ...summationArray },
                    finalColumn: finalColumn,
                    headerToColumn: headerToColumn
                });
            })
            .catch((error) => {

                if (error.stack.includes('Network Error')) {

                    this.props.defineScopeLoading(false);

                    this.setState({
                        responseMsg: 'API service is down. Please contact administrator.',
                        isError: 'Yes',
                        isLoading: false
                    });

                } else {

                    this.props.defineScopeLoading(false);

                    this.setState({
                        responseMsg: this.props.content.error,
                        isError: 'Yes',
                        isLoading: false
                    });
                }
            });
    }

    rowKeyGetter = (row) => {
        return row.DATA_COLLECTIONS_SKEY;
    }

    hideEmptyColumns() {
        let isColumnEmpty = {}
        const rowData = this.state.rowData;
        const columns = this.state.columns;
        const defaultScreenColumns = []

        for (let rowindex = 0; rowindex < rowData.length; rowindex++) {
            for (let Cindex = 0; Cindex < columns.length; Cindex++) {
                const element = columns[Cindex];

                var item = element["id"]
                var itemVal = rowData[rowindex][item]

                isColumnEmpty[item] = isColumnEmpty[item] !== undefined ? isColumnEmpty[item] && itemVal === '' : itemVal === ''
            }
        }

        let emptyColumns = []

        Object.keys(isColumnEmpty).forEach(key => {
            if (isColumnEmpty[key] &&
                !(['EXCLUSION_REASON', 'OVERRIDE_INDUSTRY_ID', 'DIRECT_SPEND', 'USER_COMMENT'].includes(key))) {
                emptyColumns.push(key)
            }
        })

        columns.forEach(item => {
            let idx = emptyColumns.findIndex(key => {
                return item.id === key
            })

            if (idx !== -1) {
                item.isSelected = false;
            } else {
                defaultScreenColumns.push(item.value)
                item.isSelected = true;
            }
        })

        this.originalColumns = cloneDeep(columns);

        return { columns: columns, defaultColumns: defaultScreenColumns }
    }

    sortFilteredRows = (filteredRows) => {
        return filteredRows;
    };

    handlePageClick = data => {
        let selected = data.selected;
        let offset = Math.ceil(selected * this.state.perPage);
        this.setState({ paginatedRowFrom: offset, paginatedRowTo: (offset + this.state.perPage) });
    };

    handleFilterChange(filter) {
        var rows = [...this.state.rowData];
        this.props.detailedFileFilterText(filter)
        let newFilters = { ...this.state.filters };
        if (filter === null || filter.filterTerm == null) {
            this.setState({ filters: null, filteredRows: rows }, this.getRows(rows, {}))
            return;

        } else if (filter.filterTerm) {
            newFilters[filter.column.key] = filter;
        } else {
            delete newFilters[filter.column.key];
        }

        this.props.detailedFileFilters(newFilters)
        this.setState({ filters: newFilters }, this.getRows(rows, newFilters))

        return newFilters;
    };

    getValidFilterValues(columnId) {
        // For Addressable Spend, return the explicit options to avoid conflicts
        if (columnId === 'ADDRESSABLE_SPEND') {
            return ['Yes', 'No'];
        }
        var rows = this.state.rowData
        var isFilterVisible = this.state.isFilterVisible
        this.filteredColumnValues = this.filteredColumnValues ? this.filteredColumnValues : []
        if (this.filteredColumnValues[columnId] === undefined) {
            var rows_filter = [...new Set(rows.map(item => item[columnId] != null ? item[columnId] : ""))]
            rows_filter.splice(0, 0, 'Not Included')
            this.filteredColumnValues[columnId] = rows_filter
            return rows_filter
        } else {
            return this.filteredColumnValues[columnId]
        }
    }

    getRows(rows, filters, node) {
        let normalFilters = {}
        let globalFilters = {}
        for (const [key, value] of Object.entries(filters)) {
            if (value.type === 'global') {
                globalFilters[key] = value
                delete filters[key]
            }
        }

        let hasNormalFilters = Object.values(filters).length > 0
        let hasGlobalFilters = Object.values(globalFilters).length > 0

        let filteredRowsTemp = []

        Object.values(globalFilters).forEach(filter => {
            filter.filteredRows.forEach(filteredRow => {
                let idx = filteredRowsTemp.findIndex(row => {
                    return row['DATA_COLLECTIONS_SKEY'] === filteredRow['DATA_COLLECTIONS_SKEY']
                })

                if (idx === -1) {
                    filteredRowsTemp.push(filteredRow)
                }
            })
        })

        let filteredRows = []
        if (hasNormalFilters && hasGlobalFilters) {
            rows = filteredRowsTemp
            filteredRows = selectors.getRows({ rows, filters })
        }
        else if (!hasNormalFilters && hasGlobalFilters)
            filteredRows = filteredRowsTemp
        else if (hasNormalFilters && !hasGlobalFilters)
            filteredRows = selectors.getRows({ rows, filters })
        else
            filteredRows = rows

        filteredRows = this.sortFilteredRows(filteredRows)
        var pageCount = filteredRows.length / this.state.perPage;
        let sum = this.state.summationArray
        if (Object.keys(filters).length >= 1) {
            sum = this.sum(filteredRows)
        }

        for (const [key, value] of Object.entries(globalFilters)) {
            filters[key] = value
        }

        this.setState({ filteredSummationArray: sum, filteredRows: filteredRows, paginatedRowFrom: 0, paginatedRowTo: this.state.perPage, pageCount: pageCount, filters: filters });
    }

    industryOverride() {
        if (this.props.overridedIndustryDetails !== undefined && this.props.overridedIndustryDetails !== null
            && this.props.overridedIndustryDetails.INDUSTRY_ID !== undefined && this.props.overridedIndustryDetails.INDUSTRY_ID !== null) {
            this.onGridRowsUpdated({ fromRow: this.state.industryOverrideRowNo, toRow: this.state.industryOverrideRowNo, updated: { 'OVERRIDE_INDUSTRY_ID': this.props.overridedIndustryDetails.INDUSTRY_ID } })
            this.props.selectedIndustryDetails(null)
            this.setState({ open: !this.state.open })
        }
    }

    clearIndustryOverride() {
        this.onGridRowsUpdated({ fromRow: this.state.industryOverrideRowNo, toRow: this.state.industryOverrideRowNo, updated: { 'OVERRIDE_INDUSTRY_ID': '' } })
        this.setState({ open: !this.state.open })
    }

    closePopUp() {
        this.setState({ open: !this.state.open })
    }

    outsidePopupClick() {
        this.setState({ open: false })
    }

    enablementWaveInput() {
        if (this.props.enablementWaveInputDetails !== undefined && this.props.enablementWaveInputDetails !== null) {
            this.onGridRowsUpdated({ fromRow: this.state.enablementWaveInputRowNo, toRow: this.state.enablementWaveInputRowNo, updated: { 'ENABLEMENT_WAVE': this.props.enablementWaveInputDetails == '' || this.props.enablementWaveInputDetails == 0 ? 1 : this.props.enablementWaveInputDetails } })
            this.props.selectedEnablementWaveDetails(null)
        }
        this.setState({ openEnablementInsightPopUp: !this.state.openEnablementInsightPopUp })
    }

    clearEnablementWaveOverride() {
        this.onGridRowsUpdated({ fromRow: this.state.enablementWaveInputRowNo, toRow: this.state.enablementWaveInputRowNo, updated: { 'ENABLEMENT_WAVE': '' } })
        this.setState({ openEnablementInsightPopUp: !this.state.openEnablementInsightPopUp })
    }

    closeEnablementInsightPopUp() {
        this.setState({ openEnablementInsightPopUp: !this.state.openEnablementInsightPopUp })
    }

    outsideEnablementInsightPopupClick() {
        this.setState({ openEnablementInsightPopUp: false })
    }

    addUserComments(comments) {
        this.onGridRowsUpdated({ fromRow: this.state.userCommentsRowNo, toRow: this.state.userCommentsRowNo, updated: { 'USER_COMMENT': comments } })
        this.setState({ openUserCommentsPopUp: !this.state.openUserCommentsPopUp })
    }

    clearUserComments() {
        if (moment(this.state.userCommentInsideCell, 'MM/DD/YYYY', true).isValid() === false) {
            this.onGridRowsUpdated({ fromRow: this.state.userCommentsRowNo, toRow: this.state.userCommentsRowNo, updated: { 'USER_COMMENT': '' } })
        }
        this.setState({ openUserCommentsPopUp: !this.state.openUserCommentsPopUp })
    }

    closeUserCommentsPopUp() {
        this.setState({ openUserCommentsPopUp: !this.state.openUserCommentsPopUp })
    }

    outsideUserCommentsPopupClick() {
        this.setState({ openUserCommentsPopUp: false })
    }

    capIqIdOverride() {
        if (this.props.overridedCapIqIdDetails !== undefined && this.props.overridedCapIqIdDetails !== null
            && this.props.overridedCapIqIdDetails.COMPANY_ID !== undefined && this.props.overridedCapIqIdDetails.COMPANY_ID !== null) {
            this.onGridRowsUpdated({
                fromRow: this.state.capIqIdOverrideRowNo, toRow: this.state.capIqIdOverrideRowNo,
                updated: { 'CAPIQ_COMPANY_ID': this.props.overridedCapIqIdDetails.COMPANY_ID }
            })
            this.props.selectedCapIqIdDetails(null)
            this.setState({ openCapIq: !this.state.openCapIq })
        }
    }

    clearCapIqIdOverride() {
        this.onGridRowsUpdated({ fromRow: this.state.capIqIdOverrideRowNo, toRow: this.state.capIqIdOverrideRowNo, updated: { 'CAPIQ_COMPANY_ID': '' } })
        this.setState({ openCapIq: !this.state.openCapIq })
    }

    closeCapIqIdPopUp() {
        this.setState({ openCapIq: !this.state.openCapIq })
    }

    outsideCapIqIdPopupClick() {
        this.setState({ openCapIq: false })
    }

    filterValidationRecords(e, skeys, recordType) {
        const rowData = this.state.rowData;
        const filteredRows = [];
        skeys.forEach((item) => {
            rowData.sort((a, b) => { return a['DATA_COLLECTIONS_SKEY'] - b['DATA_COLLECTIONS_SKEY'] })
            var rowIdx = binarySearchIndex(rowData, item, 'DATA_COLLECTIONS_SKEY')
            var idx = filteredRows.findIndex((item) => {
                return item['DATA_COLLECTIONS_SKEY'] === rowData[rowIdx]['DATA_COLLECTIONS_SKEY']
            })

            if (rowIdx !== -1 && idx === -1) {
                filteredRows.push(rowData[rowIdx]);
            }
        })
        let newFilters = { ...this.state.filters };
        newFilters[recordType] = { filteredRows: [...filteredRows], filterTerm: 'Yes', 'rawValue': skeys.length, type: 'global', column: { name: recordType, key: recordType } };

        this.props.detailedFileFilters(newFilters)

        this.setState({ filters: newFilters }, () => {
            this.getRows(this.state.rowData, newFilters)
        })
        e.stopPropagation();
    }

    filterToggle() {
        this.setState((previousState) => { return { filterFlag: !previousState.filterFlag } })
    }

    getValidationDiv() {
        const pendingRecords = this.state.pendingRecords;
        const warningRecords = this.state.warningRecords;
        const errorRecords = this.state.errorRecords;
        if (pendingRecords.length === 0) {
            this.props.pendingChanges(null)
            return '';
        } else {
            this.props.pendingChanges(true)
        }

        var warningRecordSize = 0;
        var totalWarningRecords = []
        Object.values(warningRecords).forEach((item) => {
            totalWarningRecords = totalWarningRecords.concat(item);
        })
        var warningDiv = Object.keys(warningRecords).map((key, index) => (
            warningRecords[key].length !== 0 ?
                <div className="grid-x medium-12 message-sub-row hand-cursor" onClick={(e) => this.filterValidationRecords(e, warningRecords[key], 'warning(s)')}>
                    <span>
                        <img width="10" src="images/Dot.svg" />
                    </span>
                    <div className="medium-10">
                        {key} {this.props.content.validationForText}
                        <span className="review-warning"> {formatThousands(warningRecords[key].length)} {this.props.content.validationRowsText}
                        </span>
                    </div>
                </div> : ''
        ))

        var errorRecordSize = 0;
        var totalErrorRecords = []
        Object.values(errorRecords).forEach((item) => {
            totalErrorRecords = totalErrorRecords.concat(item);
        })

        var errorDiv = Object.keys(errorRecords).map((key, index) => (
            errorRecords[key].length !== 0 ?
                <div className="grid-x medium-12 message-sub-row hand-cursor" onClick={(e) => this.filterValidationRecords(e, errorRecords[key], 'error(s)')}>
                    <span>
                        <img width="10" src="images/Dot.svg" />
                    </span>
                    <div className="medium-10">
                        {key} {this.props.content.validationForText}
                        <span className="review-errors"> {formatThousands(errorRecords[key].length)} {this.props.content.validationRowsText}
                        </span>
                    </div>
                </div> : ''
        ))

        var validationDiv = (
            <div className="validation-messages medium-12">
                <div className="grid-x">
                    <div className="medium-12 message-row hand-cursor" onClick={(e) => this.filterValidationRecords(e, pendingRecords, 'pending')}>
                        <span className="pending-changes">
                            <img width="15" src="images/Dot.svg" />{formatThousands(pendingRecords.length)} {this.props.content.validationRecordText} </span>
                        {this.props.content.pendingChangeMessage}
                    </div>
                    {totalWarningRecords.length > 0 ?
                        <div className="grid-x medium-12 message-row">
                            <div className="medium-11 hand-cursor" onClick={(e) => this.filterValidationRecords(e, totalWarningRecords, 'warning(s)')}>
                                <span className="review-warning">
                                    <img width="15" src="images/Dot.svg" />{formatThousands(totalWarningRecords.length)} {this.props.content.validationWarningText} </span>{this.props.content.warningChangeMessage}
                            </div>
                            <div onClick={this.warningToggle} className="float-right plus-icon medium-1">
                                {this.state.warningDiv ? <img width="10" src="images/minus-inactive.svg" /> : <img width="10" src="images/add.svg" />}
                            </div>
                            {this.state.warningDiv ? warningDiv : ''}
                        </div> : ''}
                    {totalErrorRecords.length > 0 ?
                        <div className="grid-x medium-12 message-row">
                            <div className="medium-11 hand-cursor" onClick={(e) => this.filterValidationRecords(e, totalErrorRecords, 'error(s)')}>
                                <span className="review-errors">
                                    <img width="15" src="images/Dot.svg" />{formatThousands(totalErrorRecords.length)} {this.props.content.validationErrorText} </span>{this.props.content.validationThatText}<span className="font-bold"> {this.props.content.validationMustText} </span>{this.props.content.errorChangeMessage}
                            </div>
                            <div onClick={this.errorToggle} className="float-right plus-icon medium-1">
                                {this.state.errorDiv ? <img width="10" src="images/minus-inactive.svg" /> : <img width="10" src="images/add.svg" />}
                            </div>
                            {this.state.errorDiv ? errorDiv : ''}
                        </div> : ''}
                </div>
            </div>)

        return validationDiv;
    }

    warningToggle() {
        this.setState((previousState) => { return { warningDiv: !previousState.warningDiv } })
    }

    errorToggle() {
        this.setState((previousState) => { return { errorDiv: !previousState.errorDiv } })
    }

    showModal(action) {
        this.refs[action].show()
    }

    hideModal(action) {
        this.refs[action].hide()
    }

    removeFilter(filter, item1, removeAll = false) {
        let breadCrumbsArray = this.state.filters;
        if (breadCrumbsArray) {
            Object.values(breadCrumbsArray).forEach(item => {
                // Built‑in filters (with a 'clear' method)
                if (item.type !== NumericFilterRenderer && item.type !== TextfilterRenderer && item.type !== 'global') {
                    if (item.clear) item.clear();
    
                    if (removeAll) {
                        if (Array.isArray(item.filterTerm)) {
                            item.filterTerm.length = 0;
                        } else {
                            item.filterTerm = null;
                        }
                        return;
                    }
    
                    // Array‑based filter
                    if (Array.isArray(item.filterTerm)) {
                        const idx = item.filterTerm.findIndex(t => t.value === item1 && item.column.key === filter.column.key);
                        if (idx !== -1) {
                            item.filterTerm.splice(idx, 1);
                            if (item.filterTerm.length === 0) {
                                delete breadCrumbsArray[filter.column.key];
                            }
                        }
                    }
                    // String‑based filter (custom single select)
                    else if (typeof item.filterTerm === 'string' && item.column.key === filter.column.key && item.filterTerm === item1) {
                        delete breadCrumbsArray[filter.column.key];
                    }
                }
                // Numeric, text, or global filters
                else if (removeAll || (item.column.key === filter.column.key && item.rawValue === item1)) {
                    if (item.clear) item.clear();
                    if (!removeAll) delete breadCrumbsArray[filter.column.key];
                }
            });
        }
    
        if (removeAll) {
            breadCrumbsArray = {};
        }
    
        const rows = [...this.state.rowData];
        this.setState({ filters: breadCrumbsArray }, () => {
            this.getRows(rows, breadCrumbsArray);
        });
    }

    expandFilter(item) {
        // Global, numeric, and text filters
        if (item.type === NumericFilterRenderer || item.type === TextfilterRenderer || item.type === 'global') {
            return (
                <div
                    className='breadcrumbsClose float-left'
                    content={item.rawValue}
                    onClick={() => this.removeFilter(item, item.rawValue)}
                    color
                >
                    {item.rawValue}
                    <img className="ml5" width="10" src="images/close_inactive.svg" />
                </div>
            );
        }
    
        // Multi‑select filters (array of values)
        if (Array.isArray(item.filterTerm)) {
            return item.filterTerm.map((item1) => (
                <div
                    key={item1.value}
                    className='breadcrumbsClose float-left'
                    content={item1.value}
                    onClick={() => this.removeFilter(item, item1.value)}
                    color
                >
                    {item1.value}
                    <img className="ml5" width="10" src="images/close_inactive.svg" />
                </div>
            ));
        }
    
        // Single‑select custom filters (string value, e.g. Addressable Spend)
        if (typeof item.filterTerm === 'string' && item.filterTerm !== '') {
            return (
                <div
                    className='breadcrumbsClose float-left'
                    content={item.filterTerm}
                    onClick={() => this.removeFilter(item, item.filterTerm)}
                    color
                >
                    {item.filterTerm}
                    <img className="ml5" width="10" src="images/close_inactive.svg" />
                </div>
            );
        }
    
        return null;
    }

    sum(finalRows, colDefs = this.state.columnDefs) {
        if (finalRows.length >= 1) {
            let arr2 = cloneDeep(finalRows[0]);
            for (const key in arr2) {
                arr2[key] = ''
            }

            arr2['DATA_COLLECTIONS_SKEY'] = 'Total :'

            let summationArrayKeys = ['AGGREGATE_INVOICE_COUNT', 'AGGREGATE_INVOICE_SPEND', 'AGGREGATE_PO_COUNT', 'AGGREGATE_PO_SPEND', 'AGREEGATE_PAYMENT_COUNT',
                'ERP_INVOICE_COUNT', 'ERP_PO_COUNT', 'PAYMENT_COUNT', "SAP_ARIBA_DOC_PROXY", "SAP_ARIBA_SPEND_PROXY", "SAP_ARIBA_SPEND_PROXY_USD", "AN_SMP_FEE_EST_BUYER_CURR", "ERP_INV_SPEND_IN_STD_CURR", "ENTERPRISE_ESTIM_SUPP_YIELD", "ENTERPRISE_ESTIM_SPEND_YIELD", "ENTERPRISE_ESTIM_DOC_YIELD", "ERP_DOCUMENT_CNT", "ERP_SPEND", "ESTI_CAPTURABLE_NET_TRNS_FEE_REVENUE"]

            summationArrayKeys.forEach(key => arr2[key] = 0)

            finalRows.forEach(item => {
                summationArrayKeys.forEach(key => {
                    arr2[key] += (item[key] === '' ? 0 : item[key])
                })
            })

            arr2['ENTERPRISE_ESTIM_SUPP_YIELD'] = arr2['ENTERPRISE_ESTIM_SUPP_YIELD'] / 100;
            return arr2;
        }
    }

    capIqDataCleared() {
        var array2 = [];
        let currencyCodes = this.props.discovery.currencyCodes;
        for (let i = 1; i < currencyCodes.length; i++) {
            let obj = { label: currencyCodes[i], value: currencyCodes[i].split(' - ')[0] }
            array2.push(obj);
        }
        this.setState({ currencyOption: array2 });
        let idx = array2.findIndex((element) => {
            return element.value === 'USD'
        })

        let selectedCurrencySym = this.props.currencySymbols[array2[idx].value];

        this.getCurrency({ label: selectedCurrencySym, value: array2[idx].value })

        this.setState({ selectedCurrencySymbol: selectedCurrencySym });
        this.setState({ selectedCurrency: array2[idx] });
        this.props.dispatchCapIQChange('clear')
        this.setState({ capIQId: '', selectedCapIQCompanyId: '', selectedLocation: this.props.discovery.locations[0], selectedIndustry: this.props.discovery.industries[0] })
    }

    capIqRadioButtonClicked(data) {
        this.props.userData.CapIQId = data.COMPANY_ID
        this.props.userData.CapIQCompany = data.COMPANY_NAME
        this.props.userData.Organization = data.COMPANY_NAME
        if (this.props.userData.CapIQCompany) {
            this.setState({ selectedCapIQCompanyId: this.props.userData.CapIQCompany + ' | ' + this.props.userData.CapIQId, organization: data.COMPANY_NAME }, this.callCapIQProcedure);
        } else {
            this.setState({ selectedCapIQCompanyId: '' })
        }

        this.props.userData.AnnualRevenue = data.COMPANY_REVENUE ? data.COMPANY_REVENUE + '' : null;
        let idx = this.props.discovery.locations.findIndex(item => data.COUNTRY_NAME.toLowerCase() === item.toLowerCase())
        if (idx !== -1) {
            this.props.userData.Location = idx;
            this.setState({ selectedLocation: this.props.discovery.locations[idx] });
        } else {
            this.setState({ selectedLocation: this.props.discovery.locations[0] })
        }

        if (data.AVATAR_INDUSTRY) {
            const industryIdx = this.props.discovery.industries.findIndex(item => data.AVATAR_INDUSTRY.toLowerCase() === item.toLowerCase());
            if (industryIdx !== -1) {
                this.props.userData.Industry = industryIdx;
                this.setState({ selectedIndustry: this.props.discovery.industries[industryIdx] });
            } else {
                this.setState({ selectedIndustry: this.props.discovery.industries[0] });
            }
        }
    }

    closeCapIqPopUp() {
        this.setState({ openCapIq: !this.state.openCapIq })
    }

    listenScrollEvent() {
        if (this.state.actualScroll) {
            this.setState({ actualScroll: false })
            return
        }

        this.setState({ dummyScroll: true }, () => {
            const canvas = document.getElementsByClassName('react-grid-Canvas')[0]
            const dummy = document.getElementsByClassName('scroll-dummy')[0]
            const length = this.state.columnDefs.length * 120
            const dummyScrollRatio = length / document.documentElement.clientWidth
            canvas.scrollLeft = dummy.scrollLeft
        })
    }

    getHeaderGroups(columnDefs) {
        let headerToColumn = {}
        columnDefs.forEach(item => {
            if (item.headerGroup in headerToColumn) {
                let columns = headerToColumn[item.headerGroup]
                columns.push({ name: item.name, width: item.width })
            } else {
                if (item.headerGroup === null) {
                    headerToColumn[item.name] = { name: null, width: item.width }
                } else {
                    headerToColumn[item.headerGroup] = [{ name: item.name, width: item.width }]
                }
            }
        })

        return headerToColumn
    }

    componentWillUnmount() {
    }

    saveAddressableSpendFromExcel = (records) => {

        return this.props.insertAddressableSpendRecords(
            records
        );
    }

    redirect() {
        this.props.history.push('/yourSpend');
        this.props.redirectFromEnablementTab(true);
    }

    render() {
        const isBusinessCase = this.props.user.userprofile.Roles[0].includes('Business Case') > 0;

        const paginatedRows = this.state.filteredRows.slice(this.state.paginatedRowFrom, this.state.paginatedRowTo);
        paginatedRows.splice(0, 0, { superHeader: this.state.headerToColumn })
        //paginatedRows.splice(1, 0, this.state.filteredSummationArray)
        const validationDiv = this.getValidationDiv();
        var columnDefs = this.setColumnHelpTextAndHardRefresh(paginatedRows, this.state.columnDefs);

        var filter = this.state.filters ? Object.entries(cloneDeep(this.state.filters)) : []
        var self = this;
        return (
            <div className={`medium-12 detailed-file-grid ${isBusinessCase ? 'SpendBusinessCaseDetailedFileGrid' : ''}`}>
                {/* CSS fix for filter dropdown clipping */}
                <style>{`
                    .react-grid-HeaderCell, .react-grid-HeaderCell--frozen {
                        overflow: visible !important;
                    }
                    .react-grid-Canvas {
                        overflow-x: visible !important;
                    }
                    .Select-menu-outer, .addressable-spend-filter-menu {
                        z-index: 10000 !important;
                    }
                `}</style>
                <div className="grid-x grid-padding-x">
                    <div className="medium-12">
                        {(this.state.isLoading) ?
                            <img style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto', paddingTop: '5px' }} src={path + `images/ajax-loader.gif`} alt="" />
                            : null
                        }
                        {
                            this.isAllAddressableSpendNo() &&
                            <div style={{ color: 'red', textAlign: 'center' }} className="cell pt5">At least one value should be Yes</div>
                            
                        }
                        {(this.state.isError === 'Yes') ?
                            <div style={{ color: 'red', textAlign: 'center' }} className="cell pt5">{this.state.responseMsg}</div>
                            : <div style={{ color: 'green', textAlign: 'center' }} className="cell pt5">{this.state.responseMsg}</div>
                        }
                    </div>
                </div>
                <div className='grid-x grid-padding-x'>
                    <div className='medium-8'>
                        <div className="tab-title">
                            <Popup className="report-tooltip"
                                trigger={<img style={{ marginLeft: '5px' }} className="info-icon" src="images/info-icon.svg" width="15" />}
                                position="bottom left"
                                on="hover"
                            >
                                <div>
                                    Addressable Spend functionality is used to remove unwanted supplier records from the spend file excluding them from SAP AVATAR reporting.  This is used when the spend file contains more suppliers than required for analysis and allows you to limit the analysis to a specific set of suppliers.
                                </div>
                            </Popup>
                            Addressable Spend{<VideoHelp screen={{ module: 'Spend', screenName: 'Your Spend File >> Addressable Spend' }} />}   </div>
                        
                    </div> 
                    <div className='medium-12' style={{ paddingBottom: '2px',fontSize:'14px' }}>
                            <span style={{ color: '#008fd3' }}>Addressable Spend functionality is used to remove unwanted supplier records from the spend file excluding them from SAP AVATAR reporting.  This is used when the spend file contains more suppliers than required for analysis and allows you to limit the analysis to a specific set of suppliers.</span>
                        </div>                       

                    <div className="medium-12">
                        <div className="grid-x hideBorder">
                            <div className="medium-1 large-1">
                                <PopupE className="override-large-popup"
                                    position="right center"
                                    open={this.state.open}
                                    onClose={this.outsidePopupClick}
                                    closeOnDocumentClick
                                >
                                    <div>
                                        <IndustryOverridePopUp
                                            close={this.closePopUp}
                                        />
                                    </div>
                                    <div className="popupOkBtn">
                                        <Button onClick={this.industryOverride} float type="submit" content={this.props.ui.ok} />
                                        <Button onClick={this.clearIndustryOverride} type="submit" content={this.props.content.clearOverridenIndustry} />
                                    </div>
                                </PopupE>
                            </div>
                            <div className="medium-1 large-1">
                                <PopupE className="override-large-popup"
                                    position="right center"
                                    open={this.state.openUserCommentsPopUp}
                                    onClose={this.outsideUserCommentsPopupClick}
                                    closeOnDocumentClick
                                >
                                    <div>
                                        <UserCommentsPopUp
                                            close={this.closeUserCommentsPopUp}
                                            addUserComments={this.addUserComments}
                                            clearUserComments={this.clearUserComments}
                                            userCommentInsideCell={this.state.userCommentInsideCell}
                                            DMC_ID={this.props.spendDetails.currentActiveRequest.DMC_ID}
                                            VS_ID={this.props.spendDetails.currentActiveRequest.VS_ID}
                                            SKEY={this.state.selectedSupplier}
                                        />
                                    </div>
                                </PopupE>
                            </div>
                            <div className="medium-1 large-1">
                                <PopupE className="override-large-popup2"
                                    position="right center"
                                    open={this.state.openEnablementInsightPopUp}
                                    onClose={this.outsideEnablementInsightPopupClick}
                                    closeOnDocumentClick
                                >
                                    <div>
                                        <EnablementWavePopUp
                                            enablementWaveInputValue={this.state.enablementWaveInputValue}
                                            close={this.closeEnablementInsightPopUp}
                                        />
                                    </div>
                                    <div className="popupOkBtn">
                                        <Button onClick={this.enablementWaveInput} float type="submit" content={this.props.ui.ok} />
                                        <Button onClick={this.clearEnablementWaveOverride} type="submit" content={this.props.ui.clearOverride} />
                                    </div>
                                </PopupE>
                            </div>
                            {this.state.currentScopeSource === "Industry" && this.state.industryDesc !== "Unclassified" && (this.state.currentDMCIndstryId !== null || this.state.currentDMCIndstryId >= 1000) ?
                                <div className="medium-1 large-1">
                                    <PopupE className="override-large-popup"
                                        position="right center"
                                        open={this.state.openCapIq}
                                        onClose={this.outsideCapIqIdPopupClick}
                                        closeOnDocumentClick
                                    >
                                        <div>
                                            <CapIQSearch
                                                contentData={this.props.discovery}
                                                capIqRadioButtonClicked={this.capIqRadioButtonClicked}
                                                capIqDataCleared={this.capIqDataCleared}
                                                close={this.closeCapIqPopUp}
                                                capIqIdOverride={this.capIqIdOverride}
                                                doubleCapIqId={this.state.currentCapIqId}
                                            />
                                        </div>
                                    </PopupE>
                                </div>
                                : null}
                        </div>
                    </div>
                </div>
                               
                <div className='grid-x grid-padding-x'>
                    <div className='medium-3'>
                        <div className="font-bold underline">{this.props.content.currentFilterSelection}</div>
                        <div className="defineScope">
                            {filter.length === 0 ? 'No filter currently selected' :
                                filter.map((item) => {
                                    return (
                                        (item.length === 0 || item[1].filterTerm.length === 0) ? '' :
                                            <div className="grid-x"><span className="font-small font-bold float-left pr10">{item[1].column.name}: </span><div className="medium-9">{this.expandFilter(item[1])}</div></div>
                                    )
                                })
                            }
                        </div>
                    </div>
                    <div className='medium-3'>
                        {this.state.rowData.length === 0 ? '' :
                            <div><span className="font-bold underline">{this.props.content.currentFilterRows}</span> {formatThousands(this.state.filteredRows.length)}/{formatThousands(this.state.rowData.length)} {this.props.content.totalText}</div>}
                    </div>
                    <div className='medium-6'>
                        <div className="grid-x medium-12 pr15">
                            <div className="medium-12">
                                {validationDiv}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="grid-x grid-padding-x">
                
                    <div class='medium-12 clearfix'>
                        <div className="float-left pt10">
                            <Select
                                className="border-with-DD page-number-dd dropDownContent"
                                placeholder="Page Count"
                                value={this.state.pageCountOption.filter(option => option.value === this.state.perPage)}
                                noOptionsMessage={() => null}
                                onChange={(value) => this.handlePageCountChange(value.value)}
                                options={this.state.pageCountOption}
                                isSearchable={false}
                            />
                        </div>
                        <div className="float-left pt10">
                            <ReactPaginate
                                previousLabel={'<'}
                                nextLabel={'>'}
                                breakLabel={'...'}
                                breakClassName={'break-me'}
                                pageCount={this.state.pageCount}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={5}
                                onPageChange={this.handlePageClick}
                                containerClassName={'pagination'}
                                subContainerClassName={'pages pagination'}
                                activeClassName={'active'}
                                pageClassName={'page-li'}
                                previousClassName={'previousClassName'}
                                nextClassName={'nextClassName'}
                                pageLinkClassName={'pageLinkClassName'}
                                activeLinkClassName={'activeLinkClassName'}
                            />
                        </div>
                        <div style={{ display: 'flex', gap: '15px', alignItems: 'center', marginTop: '17px', marginLeft: '90%' }}>

                        <button
    className="hand-cursor"
    onClick={() => this.showModal('UploadAddressableSpend')}
    title="Upload"
>
    <img
        width="20"
        src="images/export_active.svg"
        alt="Upload"
    />
</button>

                            <button className={classNames({
    'hand-cursor':
        this.state.isSaveInProgress
            ? false
            : !(
                this.hasRecordErrors() ||
                this.state.pendingRecords.length === 0 ||
                this.isAllAddressableSpendNo()
            ),

    'gray-scale':
        this.state.isSaveInProgress
            ? true
            : (
                this.hasRecordErrors() ||
                this.state.pendingRecords.length === 0 ||
                this.isAllAddressableSpendNo()
            )
})}
                                onClick={this.onSave} disabled={
                                    this.state.isSaveInProgress ||
                                    this.hasRecordErrors() ||
                                    this.isAllAddressableSpendNo()
                                } title={this.props.ui.save} type="submit" float >
                                <img width="20" src="images/save_active.svg" />
                            </button>
                        </div>
                    </div>
                    <div className="grid-x grid-padding-x">                    
                        <div
                            id="myGrid"
                            className={`medium-12 react-data-grid bottom-space ${isBusinessCase ? 'SpendBusinessCaseDetailedFileGrid' : ''}`}>
                            <div class="scroll-dummy" onScroll={this.listenScrollEvent.bind(this)}>
                            </div>
                            <ReactDataGrid
                                ref={(dataGrid) => { this.myOpenGrid = dataGrid; }}
                                columns={columnDefs}
                                minWidth={'100%'}
                                rowsCount={paginatedRows.length}
                                rowKeyGetter={this.rowKeyGetter}
                                minHeight={500}
                                onGridRowsUpdated={this.onGridRowsUpdated}
                                onGridSort={this.sortRows}
                                sortColumn={this.state.gridSortBy}
                                sortDirection={this.state.gridSortDirection}
                                enableCellSelect={true}
                                enableRowSelect={false}
                                rowGetter={i => paginatedRows[i]}
                                toolbar={<Toolbar enableFilter onToggleFilter={() => this.handleFilterChange(null)} numberOfRows={this.state.rowData.length} filterRowsButtonText={<span onClick={this.filterChange}>{<img className={classNames('hand-cursor',
                                    {
                                        'hand-cursor': !this.state.isLoading,
                                        'gray-scale': this.state.isLoading
                                    })} title={this.props.content.filter} width="20" src="images/filter_active.svg" />}</span>} />}
                                onAddFilter={filter => this.handleFilterChange(filter)}
                                onClearFilters={() => this.handleFilterChange(null)}
                                onFilterChange={filter => this.handleFilterChange(filter)}
                                getValidFilterValues={this.getValidFilterValues}
                                RowsContainer={ContextMenuTrigger}
                                rowRenderer={this.RowRenderer}
                                onCheckCellIsEditable={this.isCellEditable}
                                onColumnResize={(idx, width) => this.columnResize(`${idx}`, `${width}`)}
                                headerRowHeight={70}
                                disabled={this.state.isLoading}
                            />
                        </div>
                    </div>
                </div>

                <Modal
    className="column-field-modal"
    ref={'UploadAddressableSpend'}
    backdropStyle={{
        ...backdropStyle,
        pointerEvents: this.state.isBlocking ? 'none' : 'auto'
    }}
    modalStyle={columnFieldModalStyle}
    contentStyle={suggestedValueContentStyle}
>
                    <div className="grid-x grid-padding-x">
                        <div className="medium-12">
                            <button onClick={() => this.hideModal("UploadAddressableSpend")} className="close" />
                        </div>
                        <UploadAddressableSpend
                            rowData={this.state.rowData}
                            columnDefs={this.state.columnDefs}
                            spendDetails={this.props.spendDetails}
                            user={this.props.user}
                            saveRecords={this.saveAddressableSpendFromExcel}
                            reloadGrid={() => this.loadData()}
                            closePopup={() => this.hideModal('UploadAddressableSpend')}
                            setBlocking={(val) => this.setState({ isBlocking: val })}
                        />
                    </div>
</Modal>
            </div >
        )
    }
}

const mapStateToProps = state => {
    return {
        ui: state.content.ui,
        spendDetails: state.spendDetails,
        user: state.default,
        content: state.content.spendAnalysis.detailedFile,
        validation: state.content.validation,
        userData: state.valueStory,
        filter: state.detailedFileFilters.filter,
        filterText: state.detailedFileFilterText,
        overridedIndustryDetails: state.spendDetails.overridedIndustryDetails,
        enablementWaveInputDetails: state.spendDetails.enablementWaveInputDetails,
        spendDetails: state.spendDetails,
        discovery: state.content.discovery.form,
        overridedCapIqIdDetails: state.spendDetails.overridedCapIqIdDetails,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getDetailedFileSuccess: message => dispatch(getDetailedFileSuccess(message)),
        getDetailedFileFailure: error => dispatch(getDetailedFileFailure(error)),
        getDetailedFileLoading: bool => dispatch(getDetailedFileLoading(bool)),
        getAddressableSpendData: (DMCId, VSId, userEmail) => dispatch(getAddressableSpendData(DMCId, VSId, userEmail)),
        getSpendColumnsConfiguration: () => dispatch(getSpendColumnsConfiguration()),
        insertAddressableSpendRecords: (records) => dispatch(insertAddressableSpendRecords(records)),
        detailedFileFilters: filter => dispatch(detailedFileFilters(filter)),
        detailedFileFilterText: filter => dispatch(detailedFileFilterText(filter)),
        selectedIndustryDetails: message => dispatch(selectedIndustryDetails(message)),
        selectedEnablementWaveDetails: message => dispatch(selectedEnablementWaveDetails(message)),
        pendingChanges: changes => dispatch(pendingChanges(changes)),
        defineScopeLoading: bool => dispatch(defineScopeLoading(bool)),
        setResultSummaryDetails: (data) => dispatch(setResultSummaryDetails(data)),
        setTopDetails: (data) => dispatch(setTopDetails(data)),
        getSelectedColumn: (DMCId, VSId, userId) => dispatch(getSelectedColumn(DMCId, VSId, userId)),
        selectedCapIqIdDetails: message => dispatch(selectedCapIqIdDetails(message)),
        redirectFromEnablementTab: (flag) => dispatch(redirectFromEnablementTab(flag)),
    }
}

const addressableFilterStyles = {
    headerCell: {
        overflow: 'visible'
    },

    viewport: {
        overflow: 'visible'
    },

    canvas: {
        overflow: 'visible'
    },

    dropdown: {
        zIndex: 9999,
        position: 'absolute'
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AddressableSpend)